<template>
    <div></div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";

    export default {
        components: {},
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        }
    };
</script>